export default "__VITE_ASSET__c2c412a9__"